import React, { memo } from 'react';

import {
  useEnableNativeTabBarExperiment,
  useExposeNativeTabBarExperiment,
} from 'experiments/use-enable-native-tab-bar-experiment';
import ClassicTabsLayout from 'navigation/layouts/classic-tabs-layout';
import NativeTabsLayout from 'navigation/layouts/native-tabs-layout';

function TabsLayoutGate() {
  const {
    isReady,
    isTreatment,
    hasResolvedVariant,
    isPlatformEligible,
  } = useEnableNativeTabBarExperiment();
  // An ineligible platform (Android, or iOS below the Liquid Glass minimum) can never render
  // treatment, so an assignment there must not count as exposure. `isTreatment` and
  // `hasResolvedVariant` are already locked for the session by the hook itself once resolved
  // (see use-enable-native-tab-bar-experiment.ts), so this exposure call stays consistent with
  // whichever navigator is actually mounted below, even across later identity changes.
  useExposeNativeTabBarExperiment(hasResolvedVariant && isPlatformEligible);

  // Don't mount either navigator until the experiment is resolved - ineligible platforms are
  // ready immediately (see resolveNativeTabBarExperimentGate), so this only briefly delays
  // eligible iOS devices while Amplitude loads. Mounting ClassicTabsLayout first and swapping
  // to NativeTabsLayout once treatment resolves would flash the classic tab bar and reset
  // navigator state instead.
  if (!isReady) {
    return null;
  }

  return isTreatment ? <NativeTabsLayout /> : <ClassicTabsLayout />;
}

export default memo(TabsLayoutGate);
